// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class Toggler extends WebComponent {
  didMount() {
    const {
            toggleClass,
            target,
          } = this.props;

    this.on('click', () => {
      this.element.classList.toggle(toggleClass);
      const targetElement = document.querySelector(target);
      targetElement.classList.toggle(toggleClass);
      const openToggles = document.querySelectorAll('.' + toggleClass + ':not(.slide)');

      const menuToggle = document.querySelector('.header__menu-toggle');
      const fulltextToggle = document.querySelector('.header__fulltext-toggle');
      const fulltextinput = document.querySelector('.form-fulltext__input');
      const overlay = document.querySelector('.overlay');

      if ( this.element == menuToggle ) {
        overlay.classList.toggle('active');
        const popupForm = document.querySelector('.quick-contact-floating');

        if ( popupForm ) {
          popupForm.classList.toggle('hidden');
        }
      }

      if ( this.element == fulltextToggle ) {
        fulltextinput.focus();
      }

      openToggles.forEach((toggle) => {
        if ( (toggle != this.element) && (toggle != targetElement) ) {
          toggle.classList.remove(toggleClass);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Toggler.js